/* Maskavo · PDP nova (portada do protótipo pdp-localhost, 14/10/2026).
   A compra passa por window.MKSacola (assets/mk-sacola.js). Se a sacola Maskavo estiver
   desligada nas configurações do tema, adiciona pela Ajax API e leva para /cart. */
const raiz = document.querySelector('[data-mk-pdp]');
if (raiz) iniciar();

function iniciar() {
  const P = JSON.parse(raiz.querySelector('[data-mk-pdp-dados]')?.textContent || '{}');
  const D = JSON.parse(document.getElementById('mk-dados')?.textContent || '{}');
  const R = D.regras || {};
  const CAT = D.catalogo || [];
  const RAIZ = D.raiz && D.raiz !== '/' ? D.raiz.replace(/\/$/, '') + '/' : '/';
  const porHandle = Object.fromEntries(CAT.map((x) => [x.h, x]));
  if (!porHandle[P.h]) porHandle[P.h] = { h: P.h, nome: P.nome, id: P.id, preco: P.preco, peso: P.peso, thumb: P.thumb, recorte: P.recorte };
  const sabores = CAT.length ? CAT : [porHandle[P.h]];

  const $ = (s, el = raiz) => el.querySelector(s);
  const $$ = (s, el = raiz) => [...el.querySelectorAll(s)];
  const brl = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const ICO = {
    ok: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    info: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5" stroke-linecap="round"/></svg>',
    mais: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
  };
  const guarda = {
    get: (k) => { try { return localStorage.getItem(k) || ''; } catch (_) { return ''; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (_) {} },
  };

  /* regras de desconto por quantidade (as mesmas da régua da sacola) */
  const FAIXAS = (R.descAtivo ? R.faixas || [] : []).filter((f) => f.n > 0 && f.pct > 0).sort((a, b) => a.n - b.n);
  /* 29/10: recompra (VOLTA10, snippets/mk-volta10): 10% no pedido + o grátis a cada 10; sem as faixas 3%/5% */
  const VOLTA = +window.MK_VOLTA || 0;
  const pctDe = (n) => VOLTA || ([...FAIXAS].reverse().find((f) => n >= f.n) || { pct: 0 }).pct;
  /* 28/10: a cada 10 cookies no pedido, o de menor valor sai grátis (cupom CAIXA10, posto pela sacola). Não soma com
     o desconto por quantidade: com 10 ou mais vale o grátis. */
  const TAM_GRATIS = 10;
  const gratisN = (pedido) => Math.floor(pedido / TAM_GRATIS);
  const valorGratis = (lista, g) => lista.map((h) => porHandle[h]?.preco || 0).sort((a, b) => a - b).slice(0, g).reduce((s, v) => s + v, 0);
  const proxMeta = (pedido) => (VOLTA ? [] : FAIXAS).find((f) => pedido < f.n && f.n < TAM_GRATIS) || (pedido < TAM_GRATIS ? { n: TAM_GRATIS, gratis: true } : null);
  const premio = (m) => (m.gratis ? '1 cookie sai grátis' : `o pedido ganha ${m.pct}% OFF`);


  /* compra: pela sacola Maskavo quando ela existe */
  const sacolaPronta = window.MKSacola ? Promise.resolve() : new Promise((ok) => {
    document.addEventListener('mk:sacola-pronta', ok, { once: true });
    addEventListener('load', () => setTimeout(ok, 50), { once: true });
  });
  async function adicionar(items) {
    await sacolaPronta;
    if (window.MKSacola) return window.MKSacola.adicionar(items);
    const r = await fetch(RAIZ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (r.ok) location.href = RAIZ + 'cart';
    return r.ok;
  }
  const cartAtual = () => window.MKSacola?.cart || null;
  let caixaAtual = null; /* a compra preenche: devolve { handle: qtd } da caixa (o CEP usa) */

  /* ---------------- galeria ---------------- */
  const gal = $('.mk-gal');
  const trilho = $('.mk-gal__trilho', gal), palco = $('.mk-gal__palco', gal);
  const slides = $$('.mk-gal__slide', gal);
  const total = slides.length;
  $('.mk-gal__miniaturas', gal).innerHTML = slides.map((s, k) => {
    const img = s.querySelector('img');
    const leg = s.querySelector('figcaption')?.textContent || '';
    /* a miniatura do guia "chegou em casa" ganha um convite para clicar */
    const guia = s.classList.contains('mk-gal__slide--guia');
    const convite = guia ? '<span class="mk-gal__mini-guia"><b>Chegou?</b><small>5 min no forno</small></span>' : '';
    return `<button class="mk-gal__mini${guia ? ' mk-gal__mini--guia' : ''}" type="button" aria-current="${k === 0}" aria-label="${guia ? 'Ver o que fazer quando o cookie chega' : `Foto ${k + 1}: ${esc(leg)}`}" data-ir="${k}"><img src="${esc(img?.currentSrc || img?.src || '')}" alt="" width="76" height="95" loading="lazy">${convite}</button>`;
  }).join('');
  $('.mk-gal__pontos', gal).innerHTML = total > 1 ? slides.map((_, k) => `<button type="button" aria-label="Foto ${k + 1}" aria-current="${k === 0}" data-ir="${k}"></button>`).join('') : '';
  if (total < 2) $$('.mk-gal__seta, .mk-gal__cont', gal).forEach((el) => (el.hidden = true));
  let at = 0;
  slides[0]?.classList.add('is-ativo');
  const ir = (k) => {
    if (!total) return;
    at = (k + total) % total;
    trilho.style.transform = `translateX(${-at * 100}%)`;
    $$('[data-ir]', gal).forEach((b) => b.setAttribute('aria-current', +b.dataset.ir === at));
    slides.forEach((sl, k) => sl.classList.toggle('is-ativo', k === at));
    const cont = $('[data-g-at]', gal); if (cont) cont.textContent = at + 1;
  };
  gal.addEventListener('click', (e) => { const b = e.target.closest('[data-ir],[data-g]'); if (!b) return; ir(b.dataset.ir != null ? +b.dataset.ir : at + +b.dataset.g); });
  palco.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') ir(at + 1); if (e.key === 'ArrowLeft') ir(at - 1); });
  let x0 = null, dx = 0;
  palco.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; x0 = e.clientX; dx = 0; trilho.style.transition = 'none'; });
  palco.addEventListener('pointermove', (e) => { if (x0 === null) return; dx = e.clientX - x0; trilho.style.transform = `translateX(calc(${-at * 100}% + ${dx}px))`; });
  const solta = () => { if (x0 === null) return; trilho.style.transition = ''; x0 = null; if (Math.abs(dx) > 50) ir(at + (dx < 0 ? 1 : -1)); else ir(at); };
  palco.addEventListener('pointerup', solta); palco.addEventListener('pointercancel', solta);

  /* galeria presa ao rolar, mas centralizada na altura da tela (não colada no topo) */
  const centraGaleria = () => {
    if (innerWidth < 990) { gal.style.top = ''; return; }
    const cab = (document.querySelector('header-component') || document.querySelector('header'))?.getBoundingClientRect().height || 72;
    /* em tela alta (iPad em pé) o centro fica abaixo de onde a galeria nasce, e o sticky a empurrava
       para baixo deixando um buraco no topo: nunca passa da posição natural dela */
    const pdp = gal.parentElement;
    const rolador = document.querySelector('.page-wrapper');
    const rolagem = rolador && rolador.scrollHeight > rolador.clientHeight + 10 ? rolador.scrollTop : scrollY;
    const natural = pdp.getBoundingClientRect().top + rolagem + parseFloat(getComputedStyle(pdp).paddingTop || 0);
    const centro = Math.round((innerHeight - gal.offsetHeight) / 2 + cab / 3);
    gal.style.top = Math.max(cab + 16, Math.min(centro, Math.round(natural))) + 'px';
  };
  centraGaleria();
  addEventListener('resize', centraGaleria);
  slides.forEach((s) => s.querySelector('img')?.addEventListener('load', centraGaleria, { once: true }));

  const cx = $('.mk-compra');
  if (!P.disponivel || !$('.mk-formatos', cx)) { ligarCep(); ligarCards(); ligarDesenhos(); return; }

  /* ---------------- compra (21/10): a caixa abre só com este sabor ----------------
     "Quero N" só define o tamanho da caixa (N vagas) e rola até a caixa + sabores; quem escolhe os cookies
     é a pessoa. Passar de N vale (caixa livre até 40): o tamanho cresce junto. O desconto (6+ = 3%,
     8+ = 5%) vale para o PEDIDO, então soma o que já está na sacola. Ao pôr na sacola a tampa fecha. */
  $$('[data-formato-off]', cx).forEach((el) => {
    const n = +el.dataset.formatoOff, pct = pctDe(n);
    el.hidden = !pct && !gratisN(n);
    el.textContent = gratisN(n) ? '1 grátis' : pct ? `${pct}% OFF` : '';
  });

  const monta = $('[data-monta]', cx);
  const addCaixa = $('[data-add-caixa]', cx);
  const statusEl = $('[data-status]', cx);
  const atalhos = $$('input[name="formato"]', cx);
  const LIMITE = 40;
  /* 21/10: o sabor da página já vem com 1 na caixa (pedido do usuário); os outros, a pessoa escolhe */
  let fila = [P.h], tam = +(P.padrao || 1), totalAtual = 0;
  const contagem = () => fila.reduce((o, h) => ((o[h] = (o[h] || 0) + 1), o), {});
  caixaAtual = contagem;
  const naSacola = () => cartAtual()?.item_count || 0;
  const somaFila = () => fila.reduce((s, h) => s + (porHandle[h]?.preco || 0), 0);
  /* cookie de cada sabor: o recorte real (foto sem fundo); sem recorte, o ícone desenhado */
  const icone = (h) => {
    const r = porHandle[h]?.recorte;
    if (r) return `<img src="${esc(r)}" alt="" width="180" height="180" loading="lazy" draggable="false">`;
    return window.mkIcone ? window.mkIcone(h) : '';
  };
  const semMovimento = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* este sabor primeiro na lista */
  const lista = [porHandle[P.h], ...sabores.filter((x) => x.h !== P.h)].filter(Boolean);
  const plural = (n) => `${n} ${n === 1 ? 'cookie' : 'cookies'}`;
  const seta = (d) => `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;

  monta.innerHTML = `
    <div class="mk-monta__topo">
      <p class="mk-passo"><i>2</i>Escolha os sabores</p>
      <button class="mk-monta__mix" type="button" data-monta-pra-mim><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 3h5v5M4 20 21 3M21 16v5h-5M15 15l6 6M4 4l5 5"/></svg>Misturar pra mim</button>
    </div>
    <div class="mk-caixa">
      <div class="mk-caixa__tampa" aria-hidden="true"><span>Maskavo</span><small>feito em Paulínia</small></div>
      <div class="mk-caixa__corpo">
        <div class="mk-caixa__bandeja" data-bandeja></div>
        <div class="mk-caixa__fecho" aria-hidden="true"><span>Maskavo</span><small>feito em Paulínia</small><b data-fecho-n></b></div>
        <div class="mk-caixa__frente" aria-hidden="true" data-frente></div>
      </div>
      <span class="mk-caixa__selo" aria-hidden="true">Fechou!</span>
    </div>
    <p class="mk-monta__dica" data-dica></p>
    <div class="mk-ms">
      <button type="button" class="mk-ms__seta mk-ms__seta--ant" data-seta="-1" aria-label="Sabores anteriores">${seta('M15 5l-7 7 7 7')}</button>
      <ul class="mk-ms__lista" role="list" data-ms>${lista.map((x) => `
        <li class="mk-ms__item${x.h === P.h ? ' is-este' : ''}" data-sabor="${esc(x.h)}">
          <button type="button" class="mk-ms__foto" data-m="1" data-h="${esc(x.h)}" aria-label="Pôr um ${esc(x.nome)} na caixa">${icone(x.h)}<span class="mk-ms__badge" data-conta hidden></span></button>
          <span class="mk-ms__nome">${esc(x.nome)}<small>${x.h === P.h ? 'este sabor' : '&nbsp;'}</small><em>${VOLTA ? `<s>${brl(x.preco)}</s> ` : ''}${brl(Math.round((x.preco * (100 - VOLTA)) / 100))}</em></span>
          <span class="mk-qtd-mini"><button type="button" data-m="-1" data-h="${esc(x.h)}" aria-label="Tirar um ${esc(x.nome)}" disabled>−</button><output>0</output><button type="button" data-m="1" data-h="${esc(x.h)}" aria-label="Pôr um ${esc(x.nome)}">+</button></span>
        </li>`).join('')}</ul>
      <button type="button" class="mk-ms__seta mk-ms__seta--prox" data-seta="1" aria-label="Mais sabores">${seta('M9 5l7 7-7 7')}</button>
    </div>`;
  const caixa = $('.mk-caixa', monta), bandeja = $('[data-bandeja]', monta), trilhoMs = $('[data-ms]', monta);

  function pintaBandeja() {
    /* 25/10: caixa cheia ganha sempre uma vaga "+" a mais, para a pessoa ver que dá para pôr mais */
    const base = Math.max(tam, fila.length), extra = fila.length >= base && base >= 2 && fila.length < LIMITE ? 1 : 0;
    const V = Math.min(LIMITE, base + extra);
    caixa.style.setProperty('--cols', V <= 4 ? 2 : V <= 6 ? 3 : 4);
    if (bandeja.children.length !== V) bandeja.innerHTML = Array.from({ length: V }, (_, k) => `<button type="button" class="mk-caixa__vaga" data-vaga="${k}"></button>`).join('');
    [...bandeja.children].forEach((v, k) => {
      const h = fila[k] || '';
      if (v.dataset.h !== h) { v.innerHTML = h ? icone(h) : '<span class="mk-caixa__mais" aria-hidden="true">+</span>'; v.dataset.h = h; }
      v.classList.toggle('is-cheia', !!h);
      v.classList.toggle('is-extra', !h && k >= base);
      v.tabIndex = h || k >= base ? 0 : -1;
      if (h) { v.removeAttribute('aria-hidden'); v.setAttribute('aria-label', `Tirar ${porHandle[h]?.nome || ''} da caixa`); }
      else if (k >= base) { v.removeAttribute('aria-hidden'); v.setAttribute('aria-label', 'Pôr mais um cookie na caixa'); }
      else { v.setAttribute('aria-hidden', 'true'); v.removeAttribute('aria-label'); }
    });
    const n = fila.length;
    $('[data-frente]', monta).textContent = !n ? `caixa de ${tam}` : n < tam ? `${n} de ${tam}` : plural(n);
    $('[data-fecho-n]', monta).textContent = plural(n);
  }

  function pinta() {
    const n = fila.length, cont = contagem(), sac = naSacola(), pedido = n + sac;
    pintaBandeja();
    /* 1 cookie só não vai em caixa: com "Quero 1" a caixa some e fica só a escolha do sabor */
    const semCaixa = Math.max(tam, n) <= 1;
    caixa.hidden = semCaixa;
    $('[data-dica]', monta).textContent = semCaixa ? (n ? '' : 'Toque no sabor que você quer') : !n ? 'Toque num sabor para pôr na caixa' : 'Toque num cookie da caixa para tirar';
    $$('.mk-ms__item', monta).forEach((el) => {
      const q = cont[el.dataset.sabor] || 0, b = $('[data-conta]', el);
      $('output', el).textContent = q;
      $('[data-m="-1"]', el).disabled = !q;
      $$('[data-m="1"]', el).forEach((x) => (x.disabled = n >= LIMITE));
      el.classList.toggle('is-tem', !!q);
      b.hidden = !q;
      if (b.textContent !== String(q)) { b.textContent = q; b.classList.remove('is-pula'); void b.offsetWidth; b.classList.add('is-pula'); }
    });
    /* atalho marcado = tamanho da caixa; fora deles, nenhum */
    atalhos.forEach((r) => (r.checked = +r.value === Math.max(tam, n)));
    /* resumo acima do botão: total com desconto; embaixo, quanto falta para fechar a caixa ou para a próxima faixa */
    const g = gratisN(pedido), pct = g ? 0 : pctDe(pedido), prox = proxMeta(pedido);
    const cheio = somaFila(), semGratis = cheio - valorGratis(fila, Math.max(0, g - gratisN(sac)));
    const final = g ? (VOLTA ? Math.round((semGratis * (100 - VOLTA)) / 100) : semGratis) : Math.round(cheio * (1 - pct / 100));
    totalAtual = final;
    const daSacola = sac ? ` (contando ${sac} da sacola)` : '';
    const dica = n < tam ? `Faltam ${plural(tam - n)} para completar a caixa de ${tam}`
      : prox ? `Mais ${plural(prox.n - pedido)} e ${premio(prox)}${daSacola}`
      : g ? `Mais ${plural(TAM_GRATIS - (pedido % TAM_GRATIS))} e ganha o ${g + 1}º grátis${daSacola}` : '';
    const selo = g ? `${g} grátis${VOLTA ? ` + ${VOLTA}% OFF` : ''}` : pct ? `${pct}% OFF` : '';
    statusEl.innerHTML = !n ? '' :
      `${final < cheio ? `<s>${brl(cheio)}</s>` : ''}${brl(final)}${n > 1 ? ` · ${brl(Math.round(final / n))} cada` : ''}${selo ? ` <span class="mk-hl">${selo}</span>` : ''}`
      + (dica ? `<small>${dica}</small>` : '');
    addCaixa.innerHTML = !n ? 'Escolha os sabores' : `Pôr ${plural(n)} na sacola <span class="mk-btn__preco">${brl(final)}</span>`;
    pintaMinimo(); barraPinta();
  }

  /* o cookie voa da foto do sabor até a vaga */
  function voa(origem, k) {
    const destino = bandeja.children[k];
    if (!origem || !destino || caixa.hidden || semMovimento()) return Promise.resolve();
    const a = origem.getBoundingClientRect(), b = destino.getBoundingClientRect();
    if (b.bottom < 0 || b.top > innerHeight) return Promise.resolve();
    const f = document.createElement('span');
    f.className = 'mk-voa'; f.innerHTML = icone(fila[k]);
    Object.assign(f.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.append(f);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2), s = b.width / a.width;
    /* 1) levanta do lugar  2) viaja em arco até ficar sobre a vaga  3) desce e assenta */
    const sombra = (y, o) => `drop-shadow(0 ${y}px ${y}px rgba(54,23,5,${o}))`;
    const anim = f.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', filter: sombra(2, 0.25), easing: 'cubic-bezier(.2,.8,.3,1)' },
      { transform: `translate(${dx * 0.08}px, -22px) scale(1.16) rotate(-6deg)`, filter: sombra(14, 0.3), offset: 0.2, easing: 'cubic-bezier(.45,.05,.35,1)' },
      { transform: `translate(${dx}px, ${dy - 54}px) scale(${s * 1.12}) rotate(5deg)`, filter: sombra(20, 0.28), offset: 0.74, easing: 'cubic-bezier(.6,0,.9,.5)' },
      { transform: `translate(${dx}px, ${dy}px) scale(${s}) rotate(0deg)`, filter: sombra(2, 0.25) },
    ], { duration: 680, fill: 'forwards' });
    return anim.finished.catch(() => {}).then(() => f.remove());
  }
  function pousa(k) {
    const v = bandeja.children[k];
    if (v) { v.classList.remove('is-esperando', 'is-cai'); void v.offsetWidth; v.classList.add('is-cai'); }
    caixa.classList.remove('is-pula'); void caixa.offsetWidth; caixa.classList.add('is-pula');
  }
  async function poe(h, origem) {
    if (fila.length >= LIMITE) return;
    fila.push(h);
    const k = fila.length - 1;
    pinta();
    bandeja.children[k]?.classList.add('is-esperando');
    await voa(origem, k);
    pousa(k);
  }
  const tira = (h) => { const i = fila.lastIndexOf(h); if (i >= 0) { fila.splice(i, 1); pinta(); } };

  /* "Misturar pra mim": completa as vagas vazias com sabores que ainda não estão na caixa (com a caixa
     cheia, troca tudo por uma mistura nova). Com "Quero 1", vira uma caixa de 4 misturada. */
  function mistura() {
    if (tam < 2) tam = 4;
    if (fila.length >= tam) fila = [];
    const inicio = fila.length, cont = contagem();
    let opc = lista.map((x) => x.h).filter((h) => !cont[h]);
    if (!opc.length) opc = lista.map((x) => x.h);
    opc = opc.map((h) => [Math.random(), h]).sort((a, b) => a[0] - b[0]).map((x) => x[1]);
    for (let i = 0; fila.length < tam; i++) fila.push(opc[i % opc.length]);
    pinta();
    for (let k = inicio; k < fila.length; k++) setTimeout(() => pousa(k), semMovimento() ? 0 : (k - inicio) * 70);
  }

  /* vaga vazia ou "+" tocado: os sabores piscam logo abaixo e a dica diz o que fazer */
  function chamaSabores() {
    const l = trilhoMs.closest('.mk-ms') || trilhoMs;
    l.classList.remove('is-chama'); void l.offsetWidth; l.classList.add('is-chama');
    $('[data-dica]', monta).textContent = 'Toque num sabor para pôr mais um';
    const r = l.getBoundingClientRect();
    if (r.top < 60 || r.bottom > innerHeight) l.scrollIntoView({ block: 'center', behavior: semMovimento() ? 'auto' : 'smooth' });
  }

  /* rola até a caixa + sabores, logo abaixo do cabeçalho (no celular; no computador já está à vista) */
  function rolaAteMonta(forca) {
    if (!forca && innerWidth >= 990) return;
    const cab = document.querySelector('header-component') || document.querySelector('header');
    const topoCab = cab ? Math.max(0, cab.getBoundingClientRect().bottom) : 0;
    const dy = monta.getBoundingClientRect().top - Math.max(64, topoCab) - 10;
    if (Math.abs(dy) < 8) return;
    const rolador = document.querySelector('.page-wrapper');
    const el = rolador && rolador.scrollHeight > rolador.clientHeight + 10 ? rolador : window;
    el.scrollBy({ top: dy, behavior: semMovimento() ? 'auto' : 'smooth' });
  }
  function escolheTam(N, rola) {
    tam = N;
    if (fila.length > tam) fila = fila.slice(0, tam);
    pinta();
    if (rola) requestAnimationFrame(() => rolaAteMonta());
  }

  /* "Quero N" (também ao tocar no que já está marcado) */
  cx.addEventListener('click', (e) => {
    const r = e.target.closest('input[name="formato"]');
    if (r) escolheTam(+r.value, true);
  });
  monta.addEventListener('click', (e) => {
    const vaga = e.target.closest('[data-vaga]');
    if (vaga) { if (vaga.classList.contains('is-cheia')) { fila.splice(+vaga.dataset.vaga, 1); pinta(); } else chamaSabores(); return; }
    const b = e.target.closest('[data-m]');
    if (b && !b.disabled) {
      if (+b.dataset.m > 0) poe(b.dataset.h, b.closest('.mk-ms__item')?.querySelector('.mk-ms__foto img'));
      else tira(b.dataset.h);
      return;
    }
    if (e.target.closest('[data-monta-pra-mim]')) { mistura(); return; }
    const st = e.target.closest('[data-seta]');
    if (st) trilhoMs.scrollBy({ left: +st.dataset.seta * Math.max(140, trilhoMs.clientWidth * 0.8), behavior: semMovimento() ? 'auto' : 'smooth' });
  });
  /* setas do carrossel: somem no começo/fim */
  const setas = () => {
    const fim = trilhoMs.scrollWidth - trilhoMs.clientWidth - 4;
    $('[data-seta="-1"]', monta).disabled = trilhoMs.scrollLeft <= 4;
    $('[data-seta="1"]', monta).disabled = trilhoMs.scrollLeft >= fim;
  };
  trilhoMs.addEventListener('scroll', setas, { passive: true });
  addEventListener('resize', setas);

  /* pôr na sacola: a tampa fecha, a caixa vai e volta vazia no mesmo tamanho */
  addCaixa.addEventListener('click', async () => {
    if (addCaixa.disabled) return;
    if (!fila.length) { rolaAteMonta(true); return; }
    const cont = contagem(), misto = Object.keys(cont).length > 1;
    const cod = `Caixa com ${fila.length} · ${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
    const items = Object.entries(cont).map(([h, q]) => ({ id: porHandle[h].id, quantity: q, ...(misto ? { properties: { _caixa: cod } } : {}) }));
    ocupado(addCaixa, true);
    caixa.classList.add('is-fechando');
    const r = caixa.getBoundingClientRect();
    if (!semMovimento() && !caixa.hidden && r.bottom > 0 && r.top < innerHeight) await new Promise((ok) => setTimeout(ok, 1000));
    const ok = await adicionar(items);
    ocupado(addCaixa, false);
    caixa.classList.remove('is-fechando');
    if (ok !== false) fila = [P.h];
    pinta();
  });
  function ocupado(b, liga) { b.toggleAttribute('aria-busy', liga); b.style.opacity = liga ? '.6' : ''; b.style.pointerEvents = liga ? 'none' : ''; }

  /* aviso do pedido mínimo (caixa + o que já está na sacola): só aparece quando ainda falta */
  function pintaMinimo() {
    const el = $('[data-minimo]', cx); if (!el) return;
    const min = R.minimo || 0;
    const c0 = cartAtual(), naSac = c0 ? c0.total_price : 0;
    const somaCx = Math.round(somaFila() * (1 - pctDe(fila.length + naSacola()) / 100));
    if (!min || !fila.length || naSac + somaCx >= min) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false; el.className = 'mk-minimo';
    el.innerHTML = `${ICO.info}<span>Pedido mínimo de <b>${brl(min)}</b>: falta <b>${brl(min - naSac - somaCx)}</b>.</span>`;
  }
  document.addEventListener('mk:sacola', () => pinta());

  /* ---------------- barra fixa ---------------- */
  const barra = raiz.querySelector('[data-barra]');
  function barraPinta() {
    if (!barra) return;
    const n = fila.length;
    barra.querySelector('[data-barra-txt]').textContent = !n ? 'Escolha os sabores' : n < tam ? `${n} de ${tam} · ${brl(totalAtual)}` : `${plural(n)} · ${brl(totalAtual)}`;
    confere();
  }
  barra?.querySelector('[data-barra-add]')?.addEventListener('click', () => addCaixa.click());
  /* aparece quando o botão já passou (rolou para baixo) ou enquanto o botão ainda está abaixo da tela.
     29/10 (Clarity): 61% saíam da página do produto sem rolar e nunca viam preço nem botão; agora a barra
     com preço e "Pôr na sacola" já aparece na abertura. */
  function confere() {
    if (!barra) return;
    const b = addCaixa.getBoundingClientRect();
    const passou = b.bottom < 0;
    const abaixo = b.top > innerHeight - 20;
    barra.classList.toggle('is-on', passou || abaixo);
  }
  if (barra) document.addEventListener('scroll', confere, { passive: true, capture: true });

  /* "Montar uma caixa de presente" */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mk-montar-presente]')) return;
    escolheTam(+(P.recomendada || 6), false);
    rolaAteMonta(true);
  });

  ligarCep();
  ligarCards();
  pinta();
  setas();
  ligarDesenhos();

  /* ---------------- CEP na PDP: estimativa, não mexe na sacola ---------------- */
  function ligarCep() {
    const form = raiz.querySelector('[data-cep-pdp]'); if (!form) return;
    const res = raiz.querySelector('[data-cep-res]');
    const U = window.MKSacola?.util;
    const mascara = (v) => { const d = String(v).replace(/\D/g, '').slice(0, 8); return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; };
    form.cep.value = mascara(guarda.get('mk-cep'));
    /* o frete leva alguns segundos na primeira consulta de cada CEP: abre a conexão com o servidor
       do frete logo, começa a cotar sozinho quando o CEP completa 8 números (sem esperar o clique)
       e guarda cada consulta, para trocar de formato e voltar não consultar de novo */
    if (D.freteApi) {
      try { const l = document.createElement('link'); l.rel = 'preconnect'; l.href = new URL(D.freteApi).origin; l.crossOrigin = ''; document.head.append(l); } catch (_) {}
    }
    const consultas = new Map();
    const consulta = (url) => {
      if (!consultas.has(url)) consultas.set(url, fetch(url).then(async (r) => ({ ok: r.ok, j: await r.json() })).catch(() => { consultas.delete(url); return { ok: false, j: {} }; }));
      return consultas.get(url);
    };
    let ultimoCep = '';
    form.addEventListener('input', (e) => {
      if (e.target.name !== 'cep') return;
      e.target.value = mascara(e.target.value);
      const limpo = e.target.value.replace(/\D/g, '');
      if (limpo.length === 8 && limpo !== ultimoCep) form.requestSubmit();
    });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await sacolaPronta;
      const util = window.MKSacola?.util || U;
      const cep = form.cep.value, limpo = cep.replace(/\D/g, '');
      if (limpo.length !== 8) { res.innerHTML = '<p class="mk-msg is-erro">Digite os 8 números do CEP.</p>'; return; }
      const uf = util ? util.ufDoCep(limpo) : '';
      if (!uf) { res.innerHTML = '<p class="mk-msg is-erro">Não achamos esse CEP. Confere os números?</p>'; return; }
      guarda.set('mk-cep', cep); ultimoCep = limpo;
      /* a cotação usa a caixa montada (esgotado: 1 deste sabor) */
      const cont = caixaAtual ? caixaAtual() : {};
      const nCx = Object.values(cont).reduce((a, b) => a + b, 0) || 1;
      const valor = Object.entries(cont).reduce((t, [h, q]) => t + (porHandle[h]?.preco || 0) * q, 0) || P.preco;
      const elegivel = R.freteGratis > 0 && (R.ufsGratis || []).includes(uf);
      const btn = form.querySelector('button');
      let lista = null, real = false;
      if (D.freteApi) {
        /* cotação real no Worker: sacola descartável com os itens deste formato */
        const itens = Object.keys(cont).length ? Object.entries(cont).map(([h, q]) => `${porHandle[h].id}:${q}`) : [`${P.id}:1`];
        btn.disabled = true; res.innerHTML = '<p class="mk-msg">Consultando os Correios… leva só uns segundinhos.</p>';
        const { ok, j } = await consulta(`${D.freteApi.replace(/\/$/, '')}/frete?cep=${limpo}&itens=${itens.join(',')}`);
        if (ok && Array.isArray(j.opcoes) && j.opcoes.length) { lista = j.opcoes; real = true; }
        btn.disabled = false;
        if (form.cep.value.replace(/\D/g, '') !== limpo) return; /* a pessoa já trocou o CEP */
      }
      const ehLocal = (o) => /^(Local Delivery|Entrega local|Entrega no mesmo dia)/i.test(o.nome);
      /* a entrega local vira a linha do Same Day abaixo; o resto (Correios) aparece sempre junto dela.
         22/10: se a cotação real voltou só com a entrega local (Correios não responderam), entra a estimativa */
      if (lista) lista = lista.filter((o) => !ehLocal(o));
      if (!lista || !lista.length) { lista = estimativa(limpo, uf, nCx, valor); real = false; }
      if (util?.dentroDoPrazo) lista = util.dentroDoPrazo(lista);
      /* Same Day L4 Flex (Campinas e região): prazo pelo relógio de SP, no Worker maskavo-sameday */
      let sd = '';
      try {
        const c = await (await fetch(`https://maskavo-sameday.maskavofactory.workers.dev/cobertura?cep=${limpo}`)).json();
        if (c.atende && form.cep.value.replace(/\D/g, '') === limpo) {
          const quando = c.previsao.charAt(0).toUpperCase() + c.previsao.slice(1) + (c.hoje ? '' : ' (pedido depois das 11h, fim de semana ou feriado)');
          sd = `<li class="mk-frete"><span><b>Entrega no mesmo dia</b></span><span class="mk-frete__preco">${brl(c.preco)}</span><span class="mk-frete__quando">${esc(quando)} · motoboy L4 Flex · <a href="${RAIZ}pages/entrega-no-mesmo-dia?voltar=${encodeURIComponent(location.pathname)}&nome=${encodeURIComponent((document.querySelector('h1')?.textContent || '').trim())}">ver regras</a></span></li>`;
        }
      } catch (_) {}
      res.innerHTML = `<ul class="mk-fretes">${sd}${lista.map((o) => `<li class="mk-frete ${o.gratis || o.preco === 0 ? 'mk-frete--gratis' : ''}"><span><b>${esc(o.nome)}</b></span><span class="mk-frete__preco">${o.gratis || o.preco === 0 ? 'Grátis' : (real ? '' : 'cerca de ') + brl(o.preco)}</span><span class="mk-frete__quando">${util ? util.quando(o.dias) : ''}</span></li>`).join('')}</ul>
        <p class="mk-cep__aviso" style="margin-top:8px">${elegivel ? `Frete grátis acima de ${brl(R.freteGratis)} para ${uf}.` : sd ? 'No seu CEP tem entrega no mesmo dia: pagou até 11h, de terça a sexta, chega hoje.' : `Para ${uf}, o SEDEX é o caminho mais rápido para o cookie chegar fresco.`} ${real ? 'Valor para este pedido; somado ao que já está na sacola, pode mudar.' : 'Estimativa: o valor exato aparece na sacola, com o seu pedido.'}</p>`;
    });
  }
  /* Tabela montada com cotações reais da loja (08 e 14/10). Na sacola a cotação é ao vivo. */
  function estimativa(cep, uf, n, valor) {
    const reg = { SP: 'SE', RJ: 'SE', ES: 'SE', MG: 'SE', PR: 'S', SC: 'S', RS: 'S', DF: 'CO', GO: 'CO', MT: 'CO', MS: 'CO' }[uf] || ({ PA: 1, AP: 1, AM: 1, RR: 1, AC: 1, RO: 1, TO: 1 }[uf] ? 'N' : 'NE');
    const T = {
      local: [{ nome: 'SEDEX', preco: 994, dias: [1, 2] }, { nome: 'PAC', preco: 1545, dias: [5, 6] }],
      SP: [{ nome: 'Expresso', preco: 967, dias: [2, 3] }, { nome: 'SEDEX', preco: 1490, dias: [1, 2] }],
      RJ: [{ nome: 'Expresso', preco: 1327, dias: [2, 4] }, { nome: 'SEDEX', preco: 2885, dias: [1, 3] }],
      MG: [{ nome: 'Expresso', preco: 1081, dias: [2, 4] }, { nome: 'SEDEX', preco: 2885, dias: [1, 3] }],
      ES: [{ nome: 'Expresso', preco: 1450, dias: [3, 4] }, { nome: 'SEDEX', preco: 3090, dias: [1, 3] }],
      S: [{ nome: 'SEDEX', preco: 2885, dias: [2, 3] }],
      CO: [{ nome: 'SEDEX', preco: 3990, dias: [2, 3] }],
      NE: [{ nome: 'SEDEX', preco: 5193, dias: [2, 3] }],
      N: [{ nome: 'SEDEX', preco: 6059, dias: [3, 4] }],
    };
    const pref = Number(cep.slice(0, 5));
    const base = pref >= 13000 && pref <= 13149 ? T.local : T[uf] || T[reg] || [];
    const extra = Math.max(0, n - 2) * 55;
    const lista = base.map((o) => ({ ...o, preco: o.preco + extra })).sort((a, b) => a.preco - b.preco);
    if (R.freteGratis > 0 && (R.ufsGratis || []).includes(uf) && valor >= R.freteGratis && lista[0]) lista[0].gratis = true;
    return lista;
  }

  /* ---------------- desenhos que se desenham sozinhos ----------------
     Ingredientes e a caixa de presente: o traço aparece quando entram na tela
     (CSS com pathLength=1; aqui só ligamos a classe). */
  function ligarDesenhos() {
    const alvos = document.querySelectorAll('[data-mk-ing], [data-mk-desenho]');
    if (!alvos.length) return;
    const io = new IntersectionObserver((es) => es.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-desenha'); io.unobserve(en.target); }
    }), { threshold: 0.25 });
    alvos.forEach((el) => io.observe(el));
  }

  /* ---------------- "Complete sua caixa" ---------------- */
  function ligarCards() {
    document.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-card-add]'); if (!b) return;
      const antes = b.innerHTML;
      b.classList.add('is-feito'); b.innerHTML = ICO.ok + ' Na sacola';
      await adicionar([{ id: +b.dataset.cardAdd, quantity: 1 }]);
      setTimeout(() => { b.classList.remove('is-feito'); b.innerHTML = antes; }, 1800);
    });
  }
}

/* ---------- Nina falando ----------
   O texto do sabor aparece palavra por palavra no balão; enquanto isso a Nina alterna boca
   aberta e fechada. Fora da tela não anima; com movimento reduzido, mostra tudo de uma vez. */
(function ligarFala() {
  const sec = document.querySelector('[data-mk-fala]');
  if (!sec) return;
  const txt = sec.querySelector('[data-fala-texto]');
  const nina = sec.querySelector('.mk-fala__nina');
  if (!txt || !nina) return;
  const palavras = txt.textContent.trim().split(/\s+/);
  txt.innerHTML = palavras.map((p) => `<span class="mk-palavra">${p.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))}</span>`).join(' ');
  const spans = [...txt.querySelectorAll('.mk-palavra')];
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { spans.forEach((s) => s.classList.add('is-dita')); return; }
  let feito = false;
  const io = new IntersectionObserver((es) => {
    if (!es.some((e) => e.isIntersecting) || feito) return;
    feito = true; io.disconnect();
    sec.classList.add('is-falando');
    let k = 0;
    const passo = () => {
      if (k >= spans.length) { nina.classList.remove('is-boca'); sec.classList.remove('is-falando'); return; }
      spans[k].classList.add('is-dita');
      /* a boca abre a cada palavra e fecha logo depois: ritmo de fala, sem piscar */
      nina.classList.add('is-boca');
      setTimeout(() => nina.classList.remove('is-boca'), 110);
      const p = spans[k].textContent;
      k++;
      /* pausa maior em pontuação, como quem fala */
      setTimeout(passo, /[.!?…]$/.test(p) ? 480 : /[,;:]$/.test(p) ? 260 : 170);
    };
    passo();
  }, { threshold: 0.45 });
  io.observe(sec);
})();
